import { createFileRoute } from "@tanstack/react-router";
import KuraCalendar from "@/components/kura-calendar";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useKuraStatsQuery } from "@/hooks/use-kura-queries";
import { Calendar, TrendingUp } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";


export const Route = createFileRoute("/_authenticated/")({
  component: HomePage,
});

function HomePage() {

  const {
    data: stats = { total: 0, active: 0, completed: 0, thisMonth: 0, monthLabel: "" },
    isLoading
  } = useKuraStatsQuery();


  return (
    <div className="space-y-6 p-4">
      {/* Stats Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Total Kura Count Card */}
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">
              Toplam Kura Sayısı
            </CardTitle>
            <Calendar className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <div className="space-y-2">
                <Skeleton className="h-8 w-16" />
                <Skeleton className="h-4 w-32" />
              </div>
            ) : (
              <>
                <div className="text-2xl font-bold">{stats.total}</div>
                <p className="text-xs text-muted-foreground">
                  {stats.active} beklemede, {stats.completed} tamamlandı
                </p>
              </>
            )}
          </CardContent>
        </Card>

        {/* Additional Stats Card */}
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">
              Bu Ay Planlanmış
            </CardTitle>
            <TrendingUp className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <div className="space-y-2">
                <Skeleton className="h-8 w-16" />
                <Skeleton className="h-4 w-24" />
              </div>
            ) : (
              <>
                <div className="text-2xl font-bold">
                  {stats.thisMonth}
                </div>
                <p className="text-xs text-muted-foreground">
                  {stats.monthLabel}
                </p>
              </>
            )}
          </CardContent>
        </Card>
      </div>

      {/* Calendar Section */}
      <KuraCalendar />
    </div>
  );
}
